module.exports = __webpack_public_path__ + "img/MIA.54292f0c.jpg";